import connection from '@/api/connection'

export const storeOutputdetailResume = async ({ commit }, outputdetailResume) => {
  commit('setOutputdetailResumeIsCreating', true);
  await connection.post(`/outputdetailsResume/create`, outputdetailResume)
    .then(res => {
      commit('saveNewOutputdetailsResume', res.data);
      commit('setOutputdetailResumeIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailResumeIsCreating', false);
    });
}

export const updateOutputdetailResume = async ({ commit }, outputdetailResume ) => {
  commit('setOutputdetailResumeIsUpdating', true);
  await connection.put(`/outputdetailsResume/${outputdetailResume.id}/update`, outputdetailResume)
    .then(res => {
      commit('saveUpdatedOutputdetailResume', res.data);
      commit('setOutputdetailResumeIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailResumeIsUpdating', false);
    });
}

export const deleteOutputdetailResume = async ({ commit }, outputdetailResume) => {
  commit('setOutputdetailResumeIsDeleting', true);
  await connection.delete(`/outputdetailsResume/${outputdetailResume.id}/delete`)
    .then(res => {
      commit('setDeleteOutputdetailResume', res.data);
      commit('setOutputdetailResumeIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setOutputdetailResumeIsDeleting', false);
    });
}
